import { useMemo } from 'react';
import biLogger from '@wix/web-bi-logger';
export const useBiLogger = () => {
    const logger = useMemo(() => {
        return biLogger.factory().logger();
    }, []);
    return logger;
};
//# sourceMappingURL=useBiLogger.js.map